// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  CourseUpdateRequest,
  CreateCourseRequest,
  GenericApiResponseCourse,
  GenericApiResponseListCourse,
  GetAllCoursesParams,
  HTTPValidationError,
} from '../../models';

/**
 * Create a course
 * @summary Create Course
 */
export const createCourse = (
  createCourseRequest: CreateCourseRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCourse>> => {
  return axios.post(`/courses`, createCourseRequest, options);
};

export const getCreateCourseMutationOptions = <
  TData = Awaited<ReturnType<typeof createCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CreateCourseRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createCourse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCourse>>, { data: CreateCourseRequest }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createCourse(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: CreateCourseRequest },
    TContext
  >;
};

export type CreateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof createCourse>>>;
export type CreateCourseMutationBody = CreateCourseRequest;
export type CreateCourseMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Create Course
 */
export const useCreateCourse = <
  TData = Awaited<ReturnType<typeof createCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CreateCourseRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: CreateCourseRequest }, TContext> => {
  const mutationOptions = getCreateCourseMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get list of all courses
 * @summary Get Courses
 */
export const getAllCourses = (
  params?: GetAllCoursesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseListCourse>> => {
  return axios.get(`/courses`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAllCoursesQueryKey = (params?: GetAllCoursesParams) => {
  return [`/courses`, ...(params ? [params] : [])] as const;
};

export const getGetAllCoursesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCourses>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetAllCoursesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCoursesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCourses>>> = ({ signal }) =>
    getAllCourses(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCourses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllCoursesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCourses>>>;
export type GetAllCoursesQueryError = AxiosError<HTTPValidationError>;

export function useGetAllCourses<
  TData = Awaited<ReturnType<typeof getAllCourses>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params: undefined | GetAllCoursesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCourses<
  TData = Awaited<ReturnType<typeof getAllCourses>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetAllCoursesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCourses<
  TData = Awaited<ReturnType<typeof getAllCourses>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetAllCoursesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Courses
 */

export function useGetAllCourses<
  TData = Awaited<ReturnType<typeof getAllCourses>>,
  TError = AxiosError<HTTPValidationError>,
>(
  params?: GetAllCoursesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCourses>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllCoursesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get single courses
 * @summary Get Course
 */
export const getCourse = (
  courseId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCourse>> => {
  return axios.get(`/courses/${courseId}`, options);
};

export const getGetCourseQueryKey = (courseId: string) => {
  return [`/courses/${courseId}`] as const;
};

export const getGetCourseQueryOptions = <
  TData = Awaited<ReturnType<typeof getCourse>>,
  TError = AxiosError<HTTPValidationError>,
>(
  courseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCourseQueryKey(courseId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCourse>>> = ({ signal }) =>
    getCourse(courseId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!courseId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCourse>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCourseQueryResult = NonNullable<Awaited<ReturnType<typeof getCourse>>>;
export type GetCourseQueryError = AxiosError<HTTPValidationError>;

export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = AxiosError<HTTPValidationError>>(
  courseId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>> &
      Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = AxiosError<HTTPValidationError>>(
  courseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>> &
      Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>, 'initialData'>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = AxiosError<HTTPValidationError>>(
  courseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Course
 */

export function useGetCourse<TData = Awaited<ReturnType<typeof getCourse>>, TError = AxiosError<HTTPValidationError>>(
  courseId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCourse>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCourseQueryOptions(courseId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update a course
 * @summary Update Course
 */
export const updateCourse = (
  courseId: string,
  courseUpdateRequest: CourseUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCourse>> => {
  return axios.put(`/courses/${courseId}`, courseUpdateRequest, options);
};

export const getUpdateCourseMutationOptions = <
  TData = Awaited<ReturnType<typeof updateCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; data: CourseUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateCourse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCourse>>,
    { courseId: string; data: CourseUpdateRequest }
  > = (props) => {
    const { courseId, data } = props ?? {};

    return updateCourse(courseId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; data: CourseUpdateRequest },
    TContext
  >;
};

export type UpdateCourseMutationResult = NonNullable<Awaited<ReturnType<typeof updateCourse>>>;
export type UpdateCourseMutationBody = CourseUpdateRequest;
export type UpdateCourseMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Course
 */
export const useUpdateCourse = <
  TData = Awaited<ReturnType<typeof updateCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; data: CourseUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; data: CourseUpdateRequest }, TContext> => {
  const mutationOptions = getUpdateCourseMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete a course
 * @summary Delete Course
 */
export const deleteCourse = (courseId: string, options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.delete(`/courses/${courseId}`, options);
};

export const getDeleteCourseMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteCourse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCourse>>, { courseId: string }> = (props) => {
    const { courseId } = props ?? {};

    return deleteCourse(courseId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { courseId: string }, TContext>;
};

export type DeleteCourseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCourse>>>;

export type DeleteCourseMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Delete Course
 */
export const useDeleteCourse = <
  TData = Awaited<ReturnType<typeof deleteCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string }, TContext> => {
  const mutationOptions = getDeleteCourseMutationOptions(options);

  return useMutation(mutationOptions);
};
